import $ from 'jquery';
import {apiClient} from "./api";

export function setupRegister() {

    $('#register-form').on('submit', function(event) {
        event.preventDefault();

        const firstName = $('#register_first_name').val();
        const lastName = $('#register_last_name').val();
        const username = $('#register_email').val();
        const nickname = $('#register_nickname').val();
        const password1 = $('#register_password1').val();
        const password2 = $('#register_password2').val();

        // check password match
        if (password1 !== password2) {
            $('#message').text("Passwords do not match.");
            return;
        }

        apiClient('/api/sign_up/',
            {
                method: 'POST',
                useToken: false,
                body: JSON.stringify({
                    username: username,
                    nickname: nickname,
                    first_name: firstName,
                    last_name: lastName,
                    password1: password1,
                    password2: password2
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            }, (responseData) => {
                // Store the access and refresh tokens in cookies
                document.cookie = "access_token=" + responseData.access + "; path=/";
                document.cookie = "refresh_token=" + responseData.refresh + "; path=/";

                // Redirect to the dashboard or reload the page
                window.location.href = "/";
                // console.log('Post created successfully:', responseData);
            },
            (err) => {
                $('#message').text("Registration failed. Please try again.");
                // console.error('Error creating new post:', err);
            });
    });

}
